import React, { useState } from "react";

import { css } from "@emotion/react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { StoriesOverviewMainTeaserWithoutMedia } from "../Stories/elements/stories-overview-main-teaser";
import { FocalImageWithPlayButton } from "./FocalImageWithPlayButton";
import { VideoStoryElement } from "./VideoStoryElement";
import { CSS_MQ } from "../../../styles/breakpoints";
import { VideoTeaserType, type TranslatedValue } from "@swo/storefront";
import { ExpandedStoryTeaser } from "../../../layouts/stories/stories-overview-page/stories-overview-page-layout";

export const VideoStoriesOverviewComponents: ReactTFC<{
  mainTeaser: VideoTeaserType;
  videoStoryElements: Array<Omit<VideoTeaserType, "tags"> & { tags: ExpandedStoryTeaser["tags"] }>;
}> = props => {
  const { imageWithFocalPoint: mainTeaserImage, link, ...restOfMainTeaser } = props.mainTeaser;

  const mainTeaserProps: Omit<ExpandedStoryTeaser, "imageWithFocalPoint" | "readingTime"> & {
    readingTime: TranslatedValue | undefined;
  } = {
    ...restOfMainTeaser,
    link: {
      pathname: link,
      hash: "#v",
    },
    readingTime: restOfMainTeaser.videoLengthLabel,
    tags: [], //restOfMainTeaser.tags.map(t => ({ ...t, expandedLink: { pathname: "#" } })), // tags disabled for video stories for now
  };

  return (
    <>
      <StoriesOverviewMainTeaserWithoutMedia {...mainTeaserProps}>
        <FocalImageWithPlayButton image={mainTeaserImage} imageSizes="(max-width: 1399px) 100vw, 1400px" />
      </StoriesOverviewMainTeaserWithoutMedia>

      <div
        css={css`
          display: grid;

          grid-gap: 40px 0;
          ${CSS_MQ.atLeastMd} {
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 50px 30px;
          }
        `}
      >
        {props.videoStoryElements.map((el, idx) => {
          return <VideoStoryElement {...el} key={el.imageWithFocalPoint.image.url + el.emoHeadline} />;
        })}
      </div>
    </>
  );
};
